import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';
import { Tabs, Tab, Dropdown, MenuItem } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import TrainingsCertificationModalEditInstructorsTab from './TrainingsCertificationModalEditInstructorsTab';
import TrainingsCertificationModalEditExaminersTab from './TrainingsCertificationModalEditExaminersTab';
import getLocale from '../../../i18n/getLocale';

class TrainingCertificationLogbooksDuplicateModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal: false,
      date: null,
      start: null,
      finish: null,
    };
    //handlers

    this.duplicate = this.duplicate.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    this.setState({ modal: newProps.modal_duplicate_props });
  }

  // Fetch salvando a edição
  duplicate (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      duplicate_id: this.props.duplicate_id,
      date: this.state.date,
      start: this.state.start,
      finish: this.state.finish,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/logbook/duplicar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.closeModal();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModal() {
    this.setState({
      modal: false,
    }, this.props.closeModalParent());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tabLogbook.tituloDuplicarSessao}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.duplicate}>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.Data}:</label>
                    <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.placeholder.Data} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.Inicio}:</label>
                    <InputMask value={this.state.start}  maskChar={null} name="start" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.placeholder.HorarioDeInicio} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>{this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.Fim}:</label>
                    <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.placeholder.HorarioDeFim} />
                  </div>
                </div>
              </div>
              <hr/>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-refresh"></i> {this.locale.Treinamentos.EditarTreinamento.tabLogbook.formularioDuplicarSessao.botaoDuplicarSessao}</button>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingCertificationLogbooksDuplicateModal;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationLogbooksDuplicateModal.js